module.exports = __webpack_public_path__ + "img/89.ad410bd6.jpg";